import { render, staticRenderFns } from "./LearnUnitLevelItem.vue?vue&type=template&id=347cb0f2&scoped=true&"
import script from "./LearnUnitLevelItem.vue?vue&type=script&lang=js&"
export * from "./LearnUnitLevelItem.vue?vue&type=script&lang=js&"
import style0 from "./LearnUnitLevelItem.vue?vue&type=style&index=0&id=347cb0f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347cb0f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
